// ReusableButton.js
import React from 'react';
import PropTypes from 'prop-types';
import './reusableButton.scss'; // Add your custom styles here

const ReusableButton = ({
  label,
  onClick,
  type = 'button',
  disabled = false,
  style = {},
  className = '',
  variant = 'primary', // e.g., 'primary', 'secondary'
  size = 'medium', // e.g., 'small', 'medium', 'large'
  buttonColor = '',
  buttonWidth = '',
  buttonHeight = '',
  borderColor = "",
  buttonName = "",
  color = "",
  borderRadius,
  icon
}) => {
  const defaultStyles = {
    background: (variant != "secondary" || buttonColor) ? buttonColor || 'var(--bm-primary-green-589500)' : '',
    border: (variant != "secondary" || borderColor) ? `1px solid ${borderColor || 'var(--bm-primary-green-589500)'}` : '',
    borderRadius: borderRadius || '10px',
    opacity: 1,
    width: buttonWidth || '200px',
    height: buttonHeight || '38px',
    color: color || '',

  };

  return (
    <button
      type={type}
      name={buttonName}
      onClick={onClick}
      disabled={disabled}
      style={{ ...style, ...defaultStyles }}
      className={`reusable-button ${variant} ${size} ${className}`}
    >
      {icon &&
        <img src={icon} className="button-icon"></img>
      }
      {label}
    </button>
  );
};

ReusableButton.propTypes = {
  label: PropTypes.string.isRequired, // The button's text
  onClick: PropTypes.func, // Function to call on click
  type: PropTypes.oneOf(['button', 'submit', 'reset']), // Button type
  disabled: PropTypes.bool, // Whether the button is disabled
  style: PropTypes.object, // Inline styles
  className: PropTypes.string, // Additional class names
  variant: PropTypes.oneOf(['primary', 'secondary', 'success', 'danger', 'disable']), // Button variant
  size: PropTypes.oneOf(['small', 'medium', 'large']), // Button size
};


export default ReusableButton;

